// 用户取，流程导航
<template>
  <div class="flow userFetchFlow">
    <ul
      class="nav"
      :style="{backgroundPositionY: -(index-1) + 'rem'}">
      <li class="li" :class="{active : index == 1}">1. 验证身份<span></span></li>
      <li class="li" :class="{active : index == 2}">2. 打开箱子</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'mailBoxUserFetchFlow',
  data () {
    return {
      index: this.$store.state.mail_index
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  },
  watch: {
    '$store.state.mail_index': function (newVal) {
      this.index = newVal
      console.log('newVal', newVal)
    }
  }
}
</script>

<style scoped>
.flow.userFetchFlow .nav{
  width: 11.02rem;
  background-image: url(../../../../static/mailBox/images/flow/userFetchFlow.png);
  background-repeat: no-repeat;
  background-position-x: 0;
  background-size: 11.02rem 2rem;
}

.flow.userFetchFlow .nav .li {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/userFetch/userFetchFlow.vue